import { PROGRESS_CACHE_PREFIX, updateCache, useCachedQuery } from '@/shared/lib/useCachedQuery';
import { fetchPracticeScenarios, postScenarioSeen } from '../api/practiceApi';
import type { PracticeKind, PracticeScenario } from './types';

/**
 * Сценарии одного вида — кешируются между заходами на главную и список «Все».
 * Статус меняется двумя путями, оба обработаны без перезапроса на каждый
 * заход: «просмотрено» — правкой кеша на месте (`markCachedScenarioSeen`),
 * «пройдено» — сбросом всего `PROGRESS_CACHE_PREFIX` на выходе из чата.
 */
export function practiceCacheKey(kind: PracticeKind): string {
  return `${PROGRESS_CACHE_PREFIX}practice:${kind}`;
}

export function usePracticeScenarios(kind: PracticeKind) {
  return useCachedQuery(practiceCacheKey(kind), () => fetchPracticeScenarios(kind));
}

const KINDS: PracticeKind[] = ['roleplay', 'idiom'];

/**
 * Снимает бейдж «Новое» — вызывается при открытии экрана-превью карточки.
 * Кеш правится сразу, не дожидаясь ответа: к возврату на главную или в «Все»
 * бейдж уже должен пропасть.
 */
export function markScenarioSeen(id: number): void {
  postScenarioSeen(id);
  for (const kind of KINDS) {
    updateCache<PracticeScenario[]>(practiceCacheKey(kind), (items) =>
      items.map((item) => (item.id === id && item.status === 'new' ? { ...item, status: 'seen' } : item)),
    );
  }
}
